module.exports = __webpack_public_path__ + "img/untitled.506.196f4f5c.png";